//import { useGetAppTranslationsQuery } from "store/translations/query";
//import { useLanguage } from "./useLanguage";
// import { useLocation, useNavigate } from "react-router";
// import { changeUrlLanguage } from "../helpers";
// import { useCallback, useMemo } from "react";
// import { bool } from "yup";
import { useEffect, useMemo } from "react";
import { useGetTranslationsQuery } from "store/api";
import { useSalesNetwork } from "./useSalesNetworks";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { setLanguage as setLanguageStore } from "store/commonSlice";
import parse from "html-react-parser";

export function _T (
    code: string,
    args: Record<string, string | number | undefined> | (number | string | undefined)[] | null = null
  ) {
    const data = localStorage.getItem("_translationData");
    if (data === "undefined" || !data) {
      return code;
    }
    const _translationData:any =  JSON.parse(data)
    if (!_translationData) {
      return code;
    }

    let result = _translationData[code];
  
    // ✅ Object-based replacement
    if (args && result && !Array.isArray(args)) {
      for (const key in args) {
        result = result.replace(new RegExp(`\\{${key}\\}`, 'g'), String(args[key]));
      }
    }
  
    // ✅ Array-based replacement: ${args[0]}, ${args[1]}, ...
    if (Array.isArray(args) && result) {
      for (let i = 0; i < args.length; i++) {
        result = result.replace(`\${args[${i}]}`, String(args[i]));
      }
    }
  
    return result ?? "TODO: " + code;
  };

const useTranslation = () => {
  const { isLoading: isNetworkLoading, network, defaultLang } = useSalesNetwork();
  const language = useAppSelector((state) => state.common.lang);
  const { data: translationData } = useGetTranslationsQuery(language  as string,
    { skip: !network || !defaultLang }
  );
  const dispatch = useAppDispatch();

  useEffect(()=>{
    if (translationData) {
      const old_translationData = localStorage.getItem("_translationData");
      const new_translationData = JSON.stringify(translationData);
      if (old_translationData !== new_translationData) {
        localStorage.setItem("_translationData", new_translationData);
        window.location.reload();
      }
    }
  }, [translationData])

  // const _t = (
  //   code: string,
  //   args: (number | string | undefined)[] | null = [],
  //   //type: "language" | "message" | "text" = "text"
  // ) => {
  //   if (!translationData) {
  //     return code;
  //   }

  //   let result = translationData[code];

  //   if (args && result) {
  //     for (let i = 0; i < args.length; i++) {
  //       result = result.replace(`\${args[${i}]}`, args[i]);
  //     }
  //   }

  //   if (result) {
  //     return result;
  //   }

  //   return code;
  // }

  const _t = (
    code: string,
    args: Record<string, string | number | undefined> | (number | string | undefined)[] | null = null
  ) => {
    if (!translationData) {
      return code;
    }
  
    let result = translationData[code];
  
    // ✅ Object-based replacement
    if (args && result && !Array.isArray(args)) {
      for (const key in args) {
        result = result.replace(new RegExp(`\\{${key}\\}`, 'g'), String(args[key]));
      }
    }
  
    // ✅ Array-based replacement: ${args[0]}, ${args[1]}, ...
    if (Array.isArray(args) && result) {
      for (let i = 0; i < args.length; i++) {
        result = result.replace(`\${args[${i}]}`, String(args[i]));
      }
    }
  
    return result ?? "TODO: " + code;
  };

  const _convertToHtml = (text: string, delimiter: string = '<br>') =>{
    let ret = "";
    text?.split(delimiter)?.map((e: any)=>{
      ret += "<text data-wrap='wrap'>" + e + "</text>";
    })
    return parse(ret);
  }

  const _tText = (text: string, delimiter: string = '<br>') =>{
    let ret = "";
    const v = _t(text);
    v.split(delimiter).map((e: any)=>{
      ret += " " + e;
    })
    return ret;
  }

  return useMemo(() => {
    return {
      t: _t,
      tHtml: (
        code: string,
        args: (number | string | undefined)[] | null = [],
        delimiter: string = '<br>'
        //type: "language" | "message" | "text" = "text"
      ) => {
        const v = _t(code, args); //, type);
        return _convertToHtml(v, delimiter);
        //return _t(code, args, type)?.replace('<br>', ' ')
      },
      convertToHtml: _convertToHtml,
      tText: _tText,
      isLoading: isNetworkLoading,
      setLanguage: (lang: string, isManual: boolean = false) => {
        lang = lang.split('-')[0]
        if (isManual){
          localStorage.setItem("_lang", lang);
        }
        dispatch(setLanguageStore(lang));
      },
      language,
      translations: translationData
    };
  }, [dispatch, isNetworkLoading, language, translationData]);
};
export default useTranslation;
